import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { ContestCertificationPopupComponent } from './contest-certification-popup/contest-certification-popup.component';
import { ReceiveCertificationPopupComponent } from './receive-certification-popup/receive-certification-popup.component';
import { DashboardRoutes } from './dashboard.routing';
import { SharedModule } from '@shared/shared.module';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule } from '@angular/forms';
import { AppComponentsModule } from '@shared/app-components.module';
import { CertificationWidgetComponent } from './certification-widget/certification-widget.component';
import { CommunicationViewerComponent } from './communication-viewer/communication-viewer.component';
import { NotificationLogViewerComponent } from './notification-log-viewer/notification-log-viewer.component';
import { NotificationLogPopupComponent } from './notification-log-viewer/notification-log-popup/notification-log-popup.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AppComponentsModule,
    LayoutModule,
    FormsModule,
    // Always at the bottom.
    DashboardRoutes
  ],
  declarations: [
    DashboardComponent,
    ContestCertificationPopupComponent,
    ReceiveCertificationPopupComponent,
    CertificationWidgetComponent,
    CommunicationViewerComponent,
    NotificationLogViewerComponent,
    NotificationLogPopupComponent
  ],
  entryComponents: [
    ContestCertificationPopupComponent,
    ReceiveCertificationPopupComponent,
    NotificationLogPopupComponent
  ]
})
export class DashboardModule {}
